// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.loadBar[data-v-ade0425e] {
  --target-width: 0px;
  animation: load-ade0425e forwards ease-out 1500ms;
}
@keyframes load-ade0425e {
from {
    width: 0%;
}
to {
    width: var(--target-width);
}
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
